import { render, staticRenderFns } from "./Turmoil.vue?vue&type=template&id=0ff6b509"
import script from "./Turmoil.vue?vue&type=script&lang=ts"
export * from "./Turmoil.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports